<template>
  <div>
    <h5>{{ $t('report.fields.loadingTitle') }}</h5>
    <div class="pb-3">
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.object.travelDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="loadedTravelDuration"
          @update:modelValue="setLoadedTravelDuration"
          @update:toggle="onToggleTimePicker('loadedTravelDuration', $event)"
        />
      </b-form-group>
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.fields.stoppedDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="stoppedDurationLoaded"
          @update:modelValue="setStoppedDurationLoaded"
          @update:toggle="onToggleTimePicker('stoppedDurationLoaded', $event)"
        />
      </b-form-group>
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.object.loadingDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="loadingDuration"
          @update:modelValue="setLoadingDuration"
          @update:toggle="onToggleTimePicker('loadingDuration', $event)"
        />
      </b-form-group>
    </div>
    <h5>{{ $t('report.fields.unloadingTitle') }}</h5>
    <div class="pb-3">
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.object.travelDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="unloadedTravelDuration"
          @update:modelValue="setUnloadedTravelDuration"
          @update:toggle="onToggleTimePicker('unloadedTravelDuration', $event)"
        />
      </b-form-group>
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.fields.stoppedDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="stoppedDurationUnloaded"
          @update:modelValue="setStoppedDurationUnloaded"
          @update:toggle="onToggleTimePicker('stoppedDurationUnloaded', $event)"
        />
      </b-form-group>
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.object.unloadingDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="unloadingDuration"
          @update:modelValue="setUnloadingDuration"
          @update:toggle="onToggleTimePicker('unloadingDuration', $event)"
        />
      </b-form-group>
    </div>
    <div class="pb-3">
      <b-form-group label-for="periode pb-1">
        <template #label>
          <div class="d-flex justify-content-between align-items-center">
            <label>{{ $t('report.object.totalRitageDuration') }}</label>
          </div>
        </template>
        <TimePicker
          ref="totalRitageDuration"
          @update:modelValue="setTotalRitageDuration"
          @update:toggle="onToggleTimePicker('totalRitageDuration', $event)"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import TimePicker from './components/TimePicker.vue'
export default {
  name: 'RitageDuration',
  components: {
    TimePicker,
  },
  emits: ['update'],
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadedTravelDuration: null,
      loadingDuration: null,
      unloadedTravelDuration: null,
      unloadingDuration: null,
      totalRitageDuration: null,
      stoppedDurationLoaded: null,
      stoppedDurationUnloaded: null,
    }
  },
  methods: {
    onToggleTimePicker(field, isOpen) {
      if (isOpen && field !== 'loadedTravelDuration') {
        this.$refs['loadedTravelDuration']?.Hide()
      }
      if (isOpen && field !== 'loadingDuration') {
        this.$refs['loadingDuration']?.Hide()
      }
      if (isOpen && field !== 'unloadedTravelDuration') {
        this.$refs['unloadedTravelDuration']?.Hide()
      }
      if (isOpen && field !== 'unloadingDuration') {
        this.$refs['unloadingDuration']?.Hide()
      }
      if (isOpen && field !== 'totalRitageDuration') {
        this.$refs['totalRitageDuration']?.Hide()
      }
      if (isOpen && field !== 'stoppedDurationLoaded') {
        this.$refs['stoppedDurationLoaded']?.Hide()
      }
      if (isOpen && field !== 'stoppedDurationUnloaded') {
        this.$refs['stoppedDurationUnloaded']?.Hide()
      }
    },
    async SetRitageDuration({
      loadedTravelDuration,
      loadingDuration,
      unloadedTravelDuration,
      unloadingDuration,
      totalRitageDuration,
      stoppedDurationLoaded,
      stoppedDurationUnloaded,
    }) {
      this.loadedTravelDuration = loadedTravelDuration ?? null
      this.loadingDuration = loadingDuration ?? null
      this.unloadedTravelDuration = unloadedTravelDuration ?? null
      this.unloadingDuration = unloadingDuration ?? null
      this.totalRitageDuration = totalRitageDuration ?? null
      this.stoppedDurationLoaded = stoppedDurationLoaded ?? null
      this.stoppedDurationUnloaded = stoppedDurationUnloaded ?? null
      await this.$nextTick()
      if (this.$refs['loadedTravelDuration']) {
        this.$refs['loadedTravelDuration'].SetTime(this.loadedTravelDuration)
      }
      if (this.$refs['loadingDuration']) {
        this.$refs['loadingDuration'].SetTime(this.loadingDuration)
      }
      if (this.$refs['unloadedTravelDuration']) {
        this.$refs['unloadedTravelDuration'].SetTime(this.unloadedTravelDuration)
      }
      if (this.$refs['unloadingDuration']) {
        this.$refs['unloadingDuration'].SetTime(this.unloadingDuration)
      }
      if (this.$refs['totalRitageDuration']) {
        this.$refs['totalRitageDuration'].SetTime(this.totalRitageDuration)
      }
      if (this.$refs['stoppedDurationLoaded']) {
        this.$refs['stoppedDurationLoaded'].SetTime(this.stoppedDurationLoaded)
      }
      if (this.$refs['stoppedDurationUnloaded']) {
        this.$refs['stoppedDurationUnloaded'].SetTime(this.stoppedDurationUnloaded)
      }
    },
    setLoadedTravelDuration(duration) {
      this.loadedTravelDuration = duration
      this.$emit('update', {
        loadedTravelDuration: duration,
      })
    },
    setLoadingDuration(duration) {
      this.loadingDuration = duration
      this.$emit('update', {
        loadingDuration: duration,
      })
    },
    setUnloadedTravelDuration(duration) {
      this.unloadedTravelDuration = duration
      this.$emit('update', {
        unloadedTravelDuration: duration,
      })
    },
    setUnloadingDuration(duration) {
      this.unloadingDuration = duration
      this.$emit('update', {
        unloadingDuration: duration,
      })
    },
    setStoppedDurationLoaded(duration) {
      this.stoppedDurationLoaded = duration
      this.$emit('update', {
        stoppedDurationLoaded: duration,
      })
    },
    setStoppedDurationUnloaded(duration) {
      this.stoppedDurationUnloaded = duration
      this.$emit('update', {
        stoppedDurationUnloaded: duration,
      })
    },
    setTotalRitageDuration(duration) {
      this.totalRitageDuration = duration
      this.$emit('update', {
        totalRitageDuration: duration,
      })
    },
  },
}
</script>
